module.exports = __webpack_public_path__ + "media/images/countrysquared/ca-e595b4fbe4ff26de3ee5e6dd50edc36f.svg";